import * as React from "react";
import { RelayEnvironmentProvider } from "react-relay";
import { EmployeeRelayEnvironment } from "./environment";

export default function EmployeeRelayProvider({
    children,
}: {
    children: React.ReactNode;
}): React.ReactElement {
    return (
        <RelayEnvironmentProvider environment={EmployeeRelayEnvironment}>
            {children}
        </RelayEnvironmentProvider>
    );
}
